import { apiClient } from './apiClient';
import type { ReceivablesSummaryDto } from '../types/kpi/receivablesSummary';

export const receivablesService = {
    // Null when the receivable ledger has never been built: the server replies 204 No Content, which
    // apiClient surfaces as undefined, and the block then renders nothing.
    getSummary: async (): Promise<ReceivablesSummaryDto | null> =>
        (await apiClient.get<ReceivablesSummaryDto>('/receivables/summary')) ?? null,
};
